export const legacyDataColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "Legacy  ID",
      accessor: "legacyId",
    },
    {
      Header: "Legacy  Name",
      accessor: "name",
    },
    {
      Header: "Created At",
      accessor: "createdAt",
    },
    {
      Header: "Action",
      accessor: "action",
    },
  ];

  export const appliedLegacyDataColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "Legacy  ID",
      accessor: "legacyId",
    },
    {
      Header: "Created At",
      accessor: "createdAt",
    },
    {
      Header: "Legacy  Name",
      accessor: "name",
    },
    {
      Header: "Applied At",
      accessor: "appliedAt",
    },
    {
      Header: "Applied By",
      accessor: "appliedBy",
    },
    
  ];
  export const legacyItem = [
    // {name:'Migrate Internal Invoices',value:'internal-invoice'},
  ]